import apiCategory from '@/api/public/category';

const defaultState = () => ({
	category: [],
	loadCategory: false,
	detailCategory: {},
	categoryPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setCategory(state, data) {
		state.category = data.data
		state.categoryPagination = data.pagination;
	},
	setLoadCategory(state, data) {
		state.loadCategory = data
	},
	setDetailCategory(state, data) {
		state.detailCategory = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearCategory(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getCategory({ commit }, params) {
		commit('setLoadCategory', true);
		return new Promise((resolve) => {
			apiCategory.getCategory(params).then(({ data: { data } }) => {
				commit('setCategory', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setCategory', { data: [], pagination: {} });
			}).then(() => {
				commit('setLoadCategory', false);
			});
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};